import React from "react";
import cx from "./cx";

const TONE_CLASS = {
    ok: 'rev-chip--ok',
    warn: 'rev-chip--warn',
    err: 'rev-chip--err',
    info: 'rev-chip--info',
    active: 'rev-chip--active',
};

/** Estado de una invitación (compartidos) → tono del chip. Una sola tabla para toda la app. */
export const SHARE_STATUS_TONE = {
    pending: 'warn',
    accepted: 'ok',
    denied: 'err',
    removed: 'err',
    owner: 'info',
};

const DOT_TONES = ['ok', 'warn', 'err', 'info'];

/**
 * Chip de estado: el color vive en el punto y en el texto, nunca relleno de marca.
 * El punto solo aparece con tono ok/warn/err/info; nunca en el neutro ni en 'active'.
 *  - tone: 'ok' | 'warn' | 'err' | 'info' | 'active' | undefined (neutro)
 *  - as: 'span' (defecto) o 'button' cuando el chip es un filtro clicable
 */
const RevChip = ({ as: As = 'span', tone, className, children, ...rest }) => (
    <As className={cx('rev-chip', TONE_CLASS[tone], className)} {...rest}>
        {DOT_TONES.includes(tone) && <span className="rev-chip__dot" aria-hidden="true" />}
        <span>{children}</span>
    </As>
);

export default RevChip;
